import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  addWhitelistError,
  addWhitelistSuccess,
  deleteSelectedWhitelistsError,
  deleteSelectedWhitelistsSuccess,
  editWhitelistError,
  editWhitelistSuccess,
  getWhitelistedError,
  getWhitelistedSuccess,
} from './actions'
import {
  BY_COMPANY_SORT_PROPERTY_CHANGE,
  BY_COMPANY_TYPE_FILTER_CHANGE,
  WHITELIST_ADD_ASYNC,
  WHITELIST_DELETE_SELECTED_ASYNC,
  WHITELIST_EDIT_ASYNC,
  WHITELIST_GET_ASYNC,
  WHITELIST_PAGE_CHANGE,
  WHITELIST_SEARCH_FILTER_CHANGE,
} from './constants'
import { selectSelectedIds } from './selectors'

const getWhitelistedEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      WHITELIST_GET_ASYNC.INITIATE,
      WHITELIST_ADD_ASYNC.SUCCESS,
      WHITELIST_EDIT_ASYNC.SUCCESS,
      BY_COMPANY_TYPE_FILTER_CHANGE,
      BY_COMPANY_SORT_PROPERTY_CHANGE,
      WHITELIST_PAGE_CHANGE,
      WHITELIST_SEARCH_FILTER_CHANGE,
      WHITELIST_DELETE_SELECTED_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.allowlist)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getWhitelisted(
          store.getState().partnerOptions.selectedCompany?.value,
          store.getState().settings.whitelist.self.byCompanyTypeFilter,
          store.getState().settings.whitelist.self.byCompanySortProperty,
          store.getState().settings.whitelist.self.search,
          store.getState().settings.whitelist.self.page,
          1000 // itemsPerPage -- temp until real pagination
        )
        .map((response) => getWhitelistedSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getWhitelistedError, error)))
        .takeUntil(action$.ofType(WHITELIST_GET_ASYNC.CANCEL))
    )

const deleteSelectedWhitelistsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(WHITELIST_DELETE_SELECTED_ASYNC.INITIATE).mergeMap(() => {
    const selectedIds = selectSelectedIds(store.getState())
    return api.settings
      .deleteSelectedWhitelists(store.getState().partnerOptions.selectedCompany?.value, selectedIds)
      .map(() => deleteSelectedWhitelistsSuccess(selectedIds))
      .catch((error) => Observable.of(epicsErrorHandler(deleteSelectedWhitelistsError, error)))
      .takeUntil(action$.ofType(WHITELIST_DELETE_SELECTED_ASYNC.CANCEL))
  })

const addWhitelistEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(WHITELIST_ADD_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .addWhitelist(store.getState().partnerOptions.selectedCompany?.value, action.payload.data)
      .switchMap((response) =>
        Observable.of(
          addToast({ message: 'Allowed item was successfully added' }),
          addWhitelistSuccess(response)
        )
      )
      .catch((error) => Observable.of(epicsErrorHandler(addWhitelistError, error)))
      .takeUntil(action$.ofType(WHITELIST_ADD_ASYNC.CANCEL))
  )

const editWhitelistEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(WHITELIST_EDIT_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .editWhitelist(store.getState().partnerOptions.selectedCompany?.value, action.payload.data)
      .switchMap((response) =>
        Observable.of(
          addToast({ message: 'Allowed item was successfully edited' }),
          editWhitelistSuccess(response)
        )
      )
      .catch((error) => Observable.of(epicsErrorHandler(editWhitelistError, error)))
      .takeUntil(action$.ofType(WHITELIST_EDIT_ASYNC.CANCEL))
  )

export default combineEpics(
  getWhitelistedEpic,
  deleteSelectedWhitelistsEpic,
  addWhitelistEpic,
  editWhitelistEpic
)
